import React from 'react';
import classNames from 'classnames';

const Option = ({ active = false }) => <i className={classNames({ fa: true, 'fa-circle-o': !active, 'fa-dot-circle-o': active })} />;

export default Option;
